import type { MapId } from '~/_shared/types/map';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type { DemographicIdCode } from '~/store/boundaryGroups/boundaryGroups.repository';
import { BoundaryTerritoryType } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import type { DataLayerId } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export const isBTGForDataLayerDemographic = ({
  boundaryGroupId,
  dataLayerId,
  demographic,
  boundaryTerritoryGroup,
  mapId,
  numberOfRanges,
}: Readonly<{
  boundaryGroupId: BoundaryGroupId | null;
  dataLayerId: DataLayerId;
  demographic: DemographicIdCode;
  boundaryTerritoryGroup: BoundaryTerritoryGroup;
  mapId: MapId | null;
  numberOfRanges: number;
}>): boolean => {
  return boundaryTerritoryGroup.mapId === mapId
    && isDataLayersArtificialBoundaryTerritoryGroup(boundaryTerritoryGroup)
    && boundaryTerritoryGroup.boundaryGroupId === boundaryGroupId
    && boundaryTerritoryGroup.settings.connectedEntityData?.id === dataLayerId
    && boundaryTerritoryGroup.settings.boundaryTerritoryType === BoundaryTerritoryType.Demographic
    && boundaryTerritoryGroup.settings.demographicId === demographic
    && boundaryTerritoryGroup.settings.rangesCount === numberOfRanges;
};
